import styled from '@emotion/styled';
import {
  mixinFlexboxRow,
  mixinHeading,
  mixinParagraphHeading,
  mixinSubHeading,
  mixinTruncate,
} from 'webapp-lib/styling';

export const Heading = styled.h1`
  ${mixinHeading}

  line-height: 24px;
  margin-bottom: var(--gutter);

  &.with-margin {
    margin: var(--gutter);
  }

  &.no-margin {
    margin: 0;
  }

  &.truncate {
    ${mixinFlexboxRow}
    min-width: 0;

    > span {
      ${mixinTruncate}
    }
  }
`;

export const SubHeading = styled.h2`
  ${mixinSubHeading};
  margin-bottom: var(--gutter);

  &.no-margin {
    margin: 0;
  }
`;

export const ParagraphHeading = styled.h3`
  ${mixinParagraphHeading};
`;

export const ContentLayoutTableHeading = styled.h2`
  ${mixinSubHeading};

  margin: var(--gutter-big);

  span {
    display: inline-block;
    max-width: 100%;

    ${mixinTruncate}
  }
`;
